import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  Fragment,
  useMemo,
} from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import {
  LayerGroup,
  MapContainer,
  TileLayer,
  useMap,
  useMapEvents,
} from "react-leaflet";
import simplify from "simplify-js";
import L from "leaflet";
import "../../../../../componentes/leaflet-migrations";
import "../../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import "leaflet-routing-machine";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import RightBarEasyMaps from "../../../../../componentes/easyMaps/rightBarEasyMaps";
import TitleBarPublic from "../../../../../componentes/easyMaps/titleBarPublic";
import DescriptionBar from "../../../../../componentes/easyMaps/descriptionBar";
import NodeIcon from "../../geolocalizado/leaflatMapa/nodeIcon";
import { PolylineCustom } from "../../geolocalizado/leaflatMapa/polyLine";
import ToolBarMapsPublic from "../../../../../componentes/easyMaps/toolbarMapsPublic";
import { useOutletContext, useParams } from "react-router-dom";
import LayerBar from "../../../../../componentes/easyMaps/layerBar";

dayjs.extend(utc);
dayjs.extend(timezone);

const LeafletMapa = forwardRef((props, ref) => {
  const {
    title,
    mapId,
    setFullScreem,
    fullScreem,
    elements = [],
    connections = [],
    setElementSelected,
    elementSelected,
    iconsElements = [],
    boundsCoordinates,
    centerCoordinates = [-10, -48],
    initialZoom,
    collapse,
  } = props;

  const [showLabel, setShowLabel] = useState(false);
  const [zoomIcons, setZoomIcons] = useState(5);
  const [contextMenu, setContextMenu] = useState(null);
  const [elementsConnected, setElementsConnected] = useState([]);
  const [openRightBar, setOpenRightBar] = useState(false);
  const [connectionSelected, setConnectionSelected] = useState(null);
  const [edgeSelected, setEdgeSelected] = useState(null);
  const [loadRouting, setLoadRouting] = useState(false);
  const [contextMenuFlow, setContextMenuFlow] = useState(null);
  const [checkChanges, setCheckChanges] = useState(null);
  const [openAlertModal, setOpenAlertModal] = useState(null);
  const [openConnection, setOpenConnection] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const { token } = useParams();
  const [showLabelEnlace, setShowLabelEnlace] = useState(true);
  const mapRef = useRef(null);
  const didSetInitialZoom = useRef(false);
  const [menuCreation, setMenuCreation] = useState(false);
  const theme = useTheme();
  const { config, configLocal, setConfigLocal, configLayer } =
    useOutletContext();
  const styles = {
    paperContainer: {
      padding: "16px ",
      display: "flex",
      alignItems: "center",
      position: "relative",
      width: "100%",
      borderRadius: 3,
      mt: 5.5,
    },
    body: {
      width: "100%",
      height: "100%",
      minWidth: "610px",
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      left: "0px",
      top: "0px",
      //zIndex: 0,
      overflow: "hidden",
    },

    mapInfoStack: {
      padding: "12px 16px",
      width: "250px",
    },
    mapInfoDataStack: {
      padding: "12px 16px",
      width: "120px",
    },
    mapInfoTitle: {
      fontSize: "0.75rem",
      lineHeight: 1.25,
      fontWeight: 600,
      letterSpacing: "0.033em",
      color: "primary.main",
    },
    mapInfoText: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      fontWeight: 400,
      textTransform: "capitalize",
    },
    fontPopup: {
      margin: "0px",
      fontSize: "10px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
    },
    titlePopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
      width: "100%",
      textAlign: "center",
      marginBottom: "10px",
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 2, // Limite de 2 linhas
      WebkitBoxOrient: "vertical",
    },
  };

  useEffect(() => {
    // setElementSelected(null);
    setConnectionSelected(null);
    setElementsConnected(null);
    setEdgeSelected(null);
  }, [showLabel]);

  useEffect(() => {
    setTimeout(() => {
      if (mapRef.current && mapRef.current.invalidateSize) {
        mapRef.current.invalidateSize();
      }
    }, 300);
  }, [collapse]);

  useImperativeHandle(ref, () => ({
    focusZoomExt(id) {
      focusZoom(id);
    },
  }));

  // -----------------------mapContext-----------------------
  function Events() {
    const map = useMap();
    const moveTimeout = useRef();
    useMapEvents({
      click(e) {
        onPaneClick(e);
      },
      zoom(e) {
        setZoomIcons(calculeZoom(map));
      },
      contextmenu(e) {
        L.DomEvent.stopPropagation(e);
      },
      move(e) {
        if (moveTimeout.current) clearTimeout(moveTimeout.current);
        moveTimeout.current = setTimeout(() => {
          const center = map.getBounds().getCenter();
          const zoom = map.getZoom();
          const url = new URL(window.location.href);
          url.searchParams.set("lat", center.lat);
          url.searchParams.set("lng", center.lng);
          url.searchParams.set("zoom", zoom);
          window.history.replaceState({}, "", url);
        }, 200);
      },
    });

    return null;
  }

  const SetZoom = () => {
    const map = useMap();
    useEffect(() => {
      if (!map) return;
      setZoomIcons(calculeZoom(map));
    }, [map]);

    return null;
  };

  const SetMaxBounds = () => {
    const map = useMap(); // Acesse o objeto `map`
    useEffect(() => {
      if (!map) return;

      // Define os limites máximos do mapa
      const southWest = L.latLng(-89.98155760646617, -180);
      const northEast = L.latLng(89.99346179538875, 180);
      const bounds = L.latLngBounds(southWest, northEast);

      map.setMaxBounds(bounds);
      map.invalidateSize();
    }, [map]);

    return null;
  };

  const SetInitialZoom = () => {
    const map = useMap();
    useEffect(() => {
      if (!map || didSetInitialZoom.current) return;
      if (initialZoom && centerCoordinates) {
        didSetInitialZoom.current = true;
        return;
      }
      if (Array.isArray(boundsCoordinates) && boundsCoordinates) {
        const dataBounds = L.latLngBounds(boundsCoordinates);
        map.fitBounds(dataBounds, {
          padding: [20, 20],
          maxZoom: 14,
        });
        didSetInitialZoom.current = true;

        const centerInPx = map.latLngToContainerPoint(centerCoordinates);
        const newCenterInPx = { ...centerInPx, x: centerInPx.x - 200 };
        const newCenterInCoords = map.containerPointToLatLng(newCenterInPx);

        map.setView(newCenterInCoords);
      }
    }, [map]);

    return null;
  };
  // ----------------------- fim mapContext-----------------------

  const calculeZoom = (map) => {
    return map_range(map.getZoom() || 0, 0, 19, 1, 9);
  };

  const formatPoints = (element) => {
    let nodeStart = null,
      nodeEnd = null;

    if (element.referenceId == elementSelected?.id) nodeStart = elementSelected;
    else nodeStart = elements.find((node) => node.id == element.referenceId);

    if (element.destinationId == elementSelected?.id) nodeEnd = elementSelected;
    else nodeEnd = elements.find((node) => node.id == element.destinationId);

    let nodeStartPosition = {
      lat: parseFloat(nodeStart?.elementConfig?.config?.coordenadas?.lat),
      long: parseFloat(nodeStart?.elementConfig?.config?.coordenadas?.long),
      active: false,
    };
    let nodeEndPosition = {
      lat: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.lat),
      long: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.long),
      active: false,
    };

    let points = [
      nodeStartPosition,
      ...(element.positionHandlers ?? []).map((a) => ({
        lat: a.y,
        long: a.x,
        active: false,
      })),
      nodeEndPosition,
    ];

    return points;
  };

  function map_range(value, low1, high1, low2, high2) {
    return parseInt(low2 + ((high2 - low2) * (value - low1)) / (high1 - low1));
  }

  function zoom(action) {
    if (!mapRef.current) return;
    const map = mapRef.current;
    let zoom = map.getZoom();
    // garante que o mapa não fique deslizando
    if (zoom > 17 && action > 0) return;
    if (zoom < 1 && action < 0) return;
    map.setZoom(zoom + action);
  }
  function focusZoom(id) {
    if (!id) return;
    let element = elements.find((node) => node.id == id);
    if (!element) return;
    let cood = element.elementConfig.config.coordenadas;
    focusZoomCoordenates(cood.lat, cood.long);
  }
  function focusZoomCoordenates(lat, lng) {
    const map = mapRef.current;
    map.flyTo([lat, lng], 14);
  }
  const onNodeClick = (event, node) => {
    const selected = elements?.find(({ id }) => id === node?.id);
    setConnectionSelected(null);
    setEdgeSelected(null);
    if (selected?.id === elementSelected?.id) {
      setElementSelected(null);
      return;
    }
    setElementSelected(JSON.parse(JSON.stringify(selected)));

    let idsElements = [selected?.id];
    let idsConnections = [];
    let elementsConnect = [];

    connections.forEach(({ referenceId, destinationId, id }) => {
      if (node?.id === destinationId || node?.id === referenceId) {
        const findElement = elements?.find(
          ({ id }) =>
            id === (node?.id === destinationId ? referenceId : destinationId)
        );
        elementsConnect.push(findElement);
        idsElements.push(findElement?.id);
        idsConnections.push(id);
      }
    });
    setElementSelected(JSON.parse(JSON.stringify(selected)));
    setElementsConnected(elementsConnect);

    const updateEntangled = (isEntangled) => ({ entangled: isEntangled });

    setOpenRightBar(true);
  };
  const onPaneClick = (e) => {
    setContextMenu(null);

    if (connectionSelected) setConnectionSelected(null);
    if (edgeSelected) setEdgeSelected(null);
    if (elementsConnected) setElementsConnected(null);
    if (elementSelected) setElementSelected(null);

    if (elementSelected || edgeSelected) {
      setEdgeSelected(null);
      //setConnectionSelected(null);
      setElementSelected(null);
    }
  };

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1202 }}>
        <TitleBarPublic
          title={title}
          center={elementSelected != null || connectionSelected != null}
        />
      </Box>
      <Box sx={styles.body}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          <ToolBarMapsPublic
            setEasyMapsConfig={setConfigLocal}
            easyMapsConfig={configLocal}
            fullScreem={fullScreem}
            setFullScreem={setFullScreem}
            showLabel={showLabel}
            setShowLabel={setShowLabel}
            setShowLabelEnlace={setShowLabelEnlace}
            showLabelEnlace={showLabelEnlace}
            tipo={0}
            collapse={collapse}
          >
            <ToolBarMapsPublic.InputZoomGeo zoom={zoom} />
          </ToolBarMapsPublic>

          <LayerBar
            elementSelected={elementSelected}
            mapId={mapId}
            collapse={collapse}
          />

          <DescriptionBar
            elementSelected={elementSelected}
            key={"descrptionbar"}
            variant="default"
            layer={configLayer?.[mapId] || "trafego"}
          />
          <MapContainer
            maxBoundsViscosity={1}
            key={fullScreem ? `mapaFull` : "mapaSingle"}
            fullscreenControl={false}
            ref={mapRef}
            id="map"
            center={centerCoordinates}
            zoom={initialZoom ?? 4}
            minZoom={3}
            zoomControl={false}
            doubleClickZoom={false}
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 0,
            }}
          >
            <TileLayer
              url={
                theme.palette.mode == "dark"
                  ? config?.mapaTile?.dark ||
                    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  : config?.mapaTile?.light ||
                    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              }
              //url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
              //url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              //url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
              //satelite
              //url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              maxZoom={19}
              attribution="&copy; OpenStreetMap contributors"
            />
            <Events />
            <SetMaxBounds />
            <SetInitialZoom />
            <SetZoom />
            <LayerGroup>
              {elements.map((element, index) => (
                <NodeIcon
                  configLocal={JSON.parse(JSON.stringify(configLocal))}
                  key={element.id + "edit" + index}
                  showLabel={showLabel}
                  size={zoomIcons}
                  iconsElement={iconsElements}
                  element={element}
                  color={theme.palette.color.icons}
                  editable={false}
                  onNodeClick={onNodeClick}
                  onNodeContextMenu={() => {}}
                  selected={element.id == elementSelected?.id}
                />
              ))}
            </LayerGroup>

            {connections.map((conn, index) => {
              let position = formatPoints(conn);

              /* linha fora o modo de edição */
              //calcula a porcentagem de utilização

              let capacidade = parseFloat(conn?.config?.capacidade) ?? 0;
              let consumo =
                (conn?.data?.trafego?.rx > conn?.data?.trafego?.tx
                  ? conn?.data?.trafego?.rx
                  : conn?.data?.trafego?.tx) / 1000000000 ?? 0;
              let percent =
                configLayer?.[mapId] == "potencia"
                  ? conn?.data?.potencia?.rx
                  : (consumo / capacidade) * 100;

              // let hostId = "null";

              // if (conn?.config?.hostOriginId) {
              //   hostId = conn?.config?.hostOriginId;
              // } else {
              //   hostId =
              //     Array.isArray(conn?.item) && conn?.item?.length > 0
              //       ? conn?.item[0]?.hostOriginId
              //       : "null";
              // }

              return (
                <PolylineCustom
                  configLine={JSON.parse(JSON.stringify(conn?.config || null))}
                  darkMode={theme.palette.mode == "dark"}
                  variant={configLayer?.[mapId] || "trafego"}
                  //disable={disableLines}
                  editMode={false}
                  configLocal={JSON.parse(JSON.stringify(configLocal))}
                  host={
                    elements.find((ele) => ele.id == conn.referenceId)?.titulo
                  }
                  data={JSON.parse(JSON.stringify(conn?.data || null))}
                  percent={conn?.data?.status ? percent : null}
                  isDown={conn.data ? !conn?.data?.status : false}
                  key={conn.id + "selected" + index}
                  positions={position.map((a) => [a.lat || 0, a.long || 0])}
                  animation={conn?.config?.animation ?? "desativada"}
                  onClick={(e) => {
                    let elemento = elements.find(
                      (ele) => ele.id == conn.referenceId
                    );

                    setElementSelected(elemento);
                    setOpenConnection(conn.id);
                  }}
                />
              );
            })}
          </MapContainer>

          <RightBarEasyMaps
            mapId={mapId}
            setFocusNodeId={focusZoom}
            open={openRightBar}
            setOpen={setOpenRightBar}
            elements={elements}
            //connections={elementsConnected}
            connections={connections}
            setElement={setElementSelected}
            setConnections={setElementsConnected}
            iconsElement={iconsElements}
            element={elementSelected?.id ? elementSelected : null}
            fullScreem={fullScreem}
            openConnection={openConnection}
            setOpenConnection={setOpenConnection}
            link={`/easyMaps/mapa/public/${
              elementSelected?.mapRef?.tipo === 0 ? "geo" : "top"
            }/${elementSelected?.mapRefId ?? ""}/${token}`}
          />
        </Box>
      </Box>
    </>
  );
});

export default LeafletMapa;
